import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    'calculationType',
    'percentOfGross',
    'scopes',
  ];

  connect() {
    this.calculationTypeChanged();
  }

  calculationTypeChanged() {
    if (this.calculationTypeTarget.value === 'percent of gross') {
      this.percentOfGrossTarget.classList.remove('hidden');
    } else {
      this.percentOfGrossTarget.classList.add('hidden');
    }
  }

  showScopes(e) {
    e.preventDefault();
    this.scopesTarget.classList.remove('hidden');
  }

  removeLocation(e) {
    e.preventDefault();
    this.element.remove();
  }
}